module.exports = __webpack_public_path__ + "img/face-viewfinder.5f3aaf42.svg";